import styled, { css } from 'styled-components';

import { flexAsColumn } from '@components/Styled/mixins';

const ITEM_HEIGHT = 20.3;
const ITEM_PADDING = 12;

// Improve this implementation with auto size
const calculateTraslateTransitionSize = numberItems => (
  (numberItems - 2) * ITEM_HEIGHT
) + ITEM_PADDING;

const OverviewContainer = styled.div`
  ${flexAsColumn()};
  
  height: min-content;
  background-color: ${({ theme }) => theme.colors.brand.main[900]};
  transform: translate(0, 0);
  transition: all 0.5s ease-out;
  padding: ${({ theme }) => theme.spacing(1)};

  > h2 {
    margin: 0;
  }

  > p {
    color: ${({ theme }) => theme.colors.neutral.gray[200]};
  }

  ${({ isCardSelected, bricksSummaryLength }) => isCardSelected && css`
    overflow: hidden;
    transform: translate(0, ${calculateTraslateTransitionSize(bricksSummaryLength)}px);
  `};
`;
export { OverviewContainer };
